import {isTarget} from "./Often";

let mouseDownEvent;

const initMouseDownEvent = () => mouseDownEvent = null;
const setMouseDownEvent = (e) => mouseDownEvent = e;
const isTargetOnMouseDown = (sizzleName) => isTarget(mouseDownEvent, sizzleName);

export {initMouseDownEvent, setMouseDownEvent, isTargetOnMouseDown}